import { TSearchPromosResponse } from '../types/searchResponse';
import { ISeoData } from '../types/seoData';

export const mapSeoData = (promosResponse: TSearchPromosResponse): ISeoData => {
  const seoData = promosResponse.seoData;

  return {
    // @ts-expect-error TODO: Убрать в CD-203170 убрать description и директиву.
    metaDescription: seoData.metaDescription || seoData.description || '',
    title: seoData.title || '',
    h1: seoData.h1 || '',
    pageDescription: seoData.pageDescription || '',
    // @ts-expect-error TODO: Убрать директиву в CD-203170
    subheader: seoData.subheader || '',
    // @ts-expect-error TODO: Убрать директиву в CD-203170
    markedList: seoData.markedList || {
      items: [],
    },
    // @ts-expect-error TODO: Убрать директиву в CD-203170
    promoCategoryDetails: seoData.promoCategoryDetails || null,
  };
};
